import { render, staticRenderFns } from "./PatternOptionProductItem.vue?vue&type=template&id=5aeab39b&scoped=true"
import script from "./PatternOptionProductItem.vue?vue&type=script&lang=js"
export * from "./PatternOptionProductItem.vue?vue&type=script&lang=js"
import style0 from "./PatternOptionProductItem.vue?vue&type=style&index=0&id=5aeab39b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeab39b",
  null
  
)

export default component.exports